import { t } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";
import * as Sentry from "@sentry/react";
import { useMutation } from "@tanstack/react-query";
import { AxiosProgressEvent } from "axios";

import { postBlobs } from "api/generated/blobs/blobs";

interface UploadBlobMutationVars {
    blobs: Blob[];
    onUploadProgress: (event: AxiosProgressEvent) => void;
}
export const useUploadBlobsMutation = () =>
    useMutation({
        mutationKey: ["uploadBlob"],
        mutationFn: (vars: UploadBlobMutationVars) => {
            const { blobs, onUploadProgress } = vars;
            return postBlobs(blobs, {
                onUploadProgress,
            });
        },
        onError: (err) => {
            emitNotification("error", t("File_Upload_Failed"));
            // Errors here should be avoided! We strongly prefer frontend validation -
            // if one invalid file is in a bulk select the whole bulk fails (Which is sad!)
            Sentry.captureException(err);
        },
    });
